var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonPositive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 63,
    rx: 31.5,
    stroke: "#E827D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41 26L29 39L22 31",
    stroke: "#E827D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonPositive);
export default __webpack_public_path__ + "static/media/button-positive.e0f6c8880778335144e0c56cffdafebf.svg";
export { ForwardRef as ReactComponent };